/**
 * Application-wide configuration
 * Contains general settings, legal texts, and other app constants
 */

export const appConfig = {
  // Terms and Conditions
  termsAndConditions: {
    title: "Algemene Voorwaarden",
    content: `
      <h2 class="text-xl font-bold mb-4">Algemene Voorwaarden</h2>

      <h3 class="text-lg font-semibold mt-4 mb-2">1. Toepassingsgebied</h3>
      <p class="mb-3">
        Deze algemene voorwaarden zijn van toepassing op alle offertes, bestellingen en overeenkomsten
        voor de levering vantuinhuiss en aanverwante producten.
      </p>

      <h3 class="text-lg font-semibold mt-4 mb-2">2. Prijzen en Betaling</h3>
      <p class="mb-3">
        Alle prijzen zijn uitgedrukt in euro en inclusief 21% BTW, tenzij anders vermeld.
        Betaling dient te geschieden binnen 30 dagen na factuurdatum.
      </p>

      <h3 class="text-lg font-semibold mt-4 mb-2">3. Levering en Plaatsing</h3>
      <p class="mb-3">
        De levertijd bedraagt gemiddeld 4-6 weken na ontvangst van de bestelling en betaling.
        De plaatsing gebeurt door ervaren monteurs volgens de geldende normen.
      </p>

      <h3 class="text-lg font-semibold mt-4 mb-2">4. Garantie</h3>
      <p class="mb-3">
        Op alletuinhuiss geldt een fabrieksgarantie van 2 jaar op materiaal- en constructiefouten.
        Normale slijtage valt niet onder de garantie.
      </p>

      <h3 class="text-lg font-semibold mt-4 mb-2">5. Annulering</h3>
      <p class="mb-3">
        Annulering van de bestelling is mogelijk tot 14 dagen na bestelling.
        Na deze termijn worden annuleringskosten in rekening gebracht.
      </p>

      <h3 class="text-lg font-semibold mt-4 mb-2">6. Aansprakelijkheid</h3>
      <p class="mb-3">
        Wij zijn niet aansprakelijk voor indirecte schade of gevolgschade.
        Onze aansprakelijkheid is beperkt tot het bedrag van de bestelling.
      </p>

      <h3 class="text-lg font-semibold mt-4 mb-2">7. Privacy</h3>
      <p class="mb-3">
        Uw persoonsgegevens worden vertrouwelijk behandeld en niet aan derden verstrekt,
        behalve voor zover nodig voor de uitvoering van de overeenkomst.
      </p>

      <h3 class="text-lg font-semibold mt-4 mb-2">8. Geschillen</h3>
      <p class="mb-3">
        Op alle overeenkomsten is Belgisch recht van toepassing.
        Geschillen worden voorgelegd aan de bevoegde rechtbank van de vestigingsplaats van de verkoper.
      </p>

      <p class="mt-6 text-sm text-gray-600">
        Laatste update: ${new Date().toLocaleDateString('nl-BE')}
      </p>
    `
  }
};
